import {
  DashboardDataTableColumnKind,
  type DashboardDataTableColumnDefinition,
} from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../lib/messages';
import type { TargetingBuilder } from '../model';
import { TargetingSummaryMenu } from './TargetingSummaryMenu';

type TargetingSummaryValue = Pick<TargetingBuilder, 'deviceTypes' | 'geoLocations'>;

export function createTargetingSummaryColumns<TTargeting extends TargetingSummaryValue>(
  deviceTypeNames: ReadonlyMap<string, string>,
): DashboardDataTableColumnDefinition<TTargeting>[] {
  return [
    {
      id: 'geoLocations',
      kind: DashboardDataTableColumnKind.Custom,
      header: dashboardT('targetingBuilder.geo'),
      headerClassName: 'w-28 text-center',
      className: 'w-28 text-center',
      cell: (targeting) => (
        <TargetingSummaryMenu
          title={dashboardT('targetingBuilder.geo')}
          groups={[
            {
              label: dashboardT('targeting.included'),
              items: targeting.geoLocations
                .filter((location) => !location.excluded)
                .map(locationLabel),
            },
            {
              label: dashboardT('targeting.excluded'),
              items: targeting.geoLocations
                .filter((location) => location.excluded)
                .map(locationLabel),
            },
          ]}
        />
      ),
    },
    {
      id: 'deviceTypes',
      kind: DashboardDataTableColumnKind.Custom,
      header: dashboardT('targetingBuilder.devices'),
      headerClassName: 'w-28 text-center',
      className: 'w-28 text-center',
      cell: (targeting) => (
        <TargetingSummaryMenu
          title={dashboardT('targetingBuilder.devices')}
          items={targeting.deviceTypes.map(
            (deviceType) => deviceTypeNames.get(deviceType.deviceTypeId) ?? deviceType.deviceTypeId,
          )}
        />
      ),
    },
  ];
}

function locationLabel(location: TargetingSummaryValue['geoLocations'][number]) {
  return location.locationName ?? location.countryName ?? location.geocodeId ?? '-';
}
